import {httpService} from "@/modules/common/services";

const getServices = (params) => {
  return httpService.get('platform/v1/scheduling/appointments',params)
}

const fetchServicesCategories = (params) => {
  let getCategoriesParams = {
    business_id: params.business_uid,
    only_visible_services: false,
    categories_array: [],
    has_future_instance: false,
    use_platform_api: true
  }
  return httpService.get('platform/v1/categories', getCategoriesParams)
}

const fetchServicesOfCategory = (params) => {
  return httpService.get(`platform/v1/categories/${params.category_id}/services`, params.category_params)
}

export default {
  getServices,
  fetchServicesCategories,
  fetchServicesOfCategory
}
